import { Component, signal } from "@angular/core";
import { SettingsModal } from "@components/settings-modal/settings-modal";
import { SettingsPanel } from "@components/settings-panel/settings-panel";

@Component({
  selector: "app-settings-button",
  standalone: true,
  imports: [SettingsModal, SettingsPanel],
  template: `
    <button class="btn-icon btn-secondary" (click)="isModalOpen.set(true)">
      <img src="assets/icons/settings.svg" alt="Open settings" />
    </button>

    <app-settings-modal [isOpen]="isModalOpen()" (closed)="isModalOpen.set(false)" (openPanel)="handleOpenPanel()" />

    <app-settings-panel [isOpen]="isPanelOpen()" (closed)="isPanelOpen.set(false)" />
  `,
})
export class SettingsButton {
  protected isModalOpen = signal(false);
  protected isPanelOpen = signal(false);

  protected handleOpenPanel() {
    this.isModalOpen.set(false);
    this.isPanelOpen.set(true);
  }
}
